import create from "./create.json";
import table from "./table.json";
import details from "./details.json";
import steps from "./steps.json";
import edit from "./edit.json";

export default {
  create,
  table,
  details,
  steps,
  edit,
};
